import React from 'react'
import { Link } from 'react-router-dom';


// import styles from "../../Styles/Footer.module.css"
import styles from "../../../styles/Footer.module.scss"
import SocialLinks from '../SocialLinks';

function Footer() {
    return (
        <div className={`${styles.Footer} `}>
            <div className={` ${styles.Footer__div}`}>
                <div className={` ${styles.first}`}>
                    <div  >
                        <Link to={'/'}>
                            <h3>Usama Tanveer</h3>
                        </Link>
                        <div className={styles.p}>
                            I have been in this field for quiet some time and with each day I strive for more and better. I am in love with this field. I take inspiration from resources out there on the internet and tries to make something out of it
                            My Motto and my speciality is Game Devlopment, by taking any given desingn I turn it into reality
                        </div>
                    </div>
                    <div className={""}>
                        <SocialLinks />
                    </div>
                </div>
                <p className={`${styles.second}`} >Copyright@{new Date().getFullYear()}</p>
            </div>
        </div >
    )
}

export default Footer